/** Kunci identitas No HP — CERMIN `backend/services/wa_service.py::periksa_kunci_hp`
 *  (brief owner 22 Sep 2026, I1: kredit retur hanya untuk nama + No HP yang sama).
 *
 *  Dipakai layar untuk UX saja (mematikan pilihan "tukar unit" pada nota tanpa
 *  No HP yang sah, petunjuk kredit). Server tetap validator akhir. Kesetaraan
 *  dengan versi Python dijaga `backend/tests/test_i1_kunci_hp.py` yang
 *  menjalankan berkas INI lewat `node` — jangan menambah impor di berkas ini
 *  (tes menyalinnya sendirian sebagai modul ES).
 */

export const PANJANG_HP_MIN = 10;
export const PANJANG_HP_MAKS = 15;

export const PESAN_HP = {
  kosong: "No HP kosong",
  angka_asing: "No HP memuat angka non-standar (mis. angka lebar penuh dari keyboard "
    + "lain) — ketik ulang dengan angka biasa 0-9",
  format_620: "format No HP salah: sesudah +62 jangan ada angka 0 "
    + "(tulis 0812… atau +62 812…)",
  pendek: `No HP terlalu pendek — minimal ${PANJANG_HP_MIN} digit termasuk kode negara, `
    + "contoh 0812 3456 7890",
  panjang: `No HP terlalu panjang — maksimal ${PANJANG_HP_MAKS} digit; periksa apakah dua `
    + "nomor tergabung jadi satu",
};

// Angka non-ASCII (kategori Unicode N*) DITOLAK, bukan dibuang: versi Python
// menyimpannya di kunci apa adanya, jadi "０８１２…" dan "0812…" — orang yang
// sama — akan jadi dua kunci berbeda. Karakter bukan-angka lain (tanda arah
// tak terlihat dari WhatsApp, spasi tak-putus) dibuang seperti biasa.
const ANGKA = /\p{N}/u;

/** { kunci, alasan } — kunci "" kalau tidak sah; alasan = kode yang sama dengan server. */
export function periksaKunciHp(noHp) {
  const teks = noHp == null ? "" : String(noHp);
  let digit = "";
  for (const ch of teks) {                 // per code point, sama dengan iterasi str Python
    const ascii = ch.codePointAt(0) < 128;
    if (!ascii && ANGKA.test(ch)) return { kunci: "", alasan: "angka_asing" };
    if (ch >= "0" && ch <= "9") digit += ch;
  }
  if (!digit) return { kunci: "", alasan: "kosong" };
  let kunci = digit;
  if (digit.startsWith("0")) kunci = "62" + digit.slice(1);
  else if (digit.startsWith("8")) kunci = "62" + digit;
  if (kunci.startsWith("620")) return { kunci: "", alasan: "format_620" };
  if (kunci.length < PANJANG_HP_MIN) return { kunci: "", alasan: "pendek" };
  if (kunci.length > PANJANG_HP_MAKS) return { kunci: "", alasan: "panjang" };
  return { kunci, alasan: "" };
}

export function kunciHp(noHp) {
  return periksaKunciHp(noHp).kunci;
}

export function hpSah(noHp) {
  return !!kunciHp(noHp);
}

export function pesanHpTidakSah(alasan) {
  return PESAN_HP[alasan] || "No HP tidak sah";
}
